{
  "create": {
    "button": "Erstellen",
    "items": {
      "organization": "Organisation",
      "project": "Projekt"
    },
    "no_permissions": "Sie haben keine Berechtigungen, um Projekte oder Services zu erstellen."
  },
  "profile": {
    "organizations": "Organisationen",
    "projects": "Projekte",
    "my_profile": "Mein Profil",
    "logout": "Abmelden"
  },
  "navigation": {
    "no_organizations": "Sie sind in keiner Organisation.",
    "no_projects": "Es sind keine Projekte vorhanden.",
    "no_projects_in_organization": "Diese Organisation hat noch keine Projekte.",
    "no_clusters_in_project": "Dieses Projekt hat noch keine Cluster.",
    "help": "Hilfe-Center",
    "admin": "Einstellungen",
    "documentation": "Dokumentation",
    "support": "Kontakt",
    "setup": "Einrichtung"
  },
  "footer": {
    "copyright": "© 2000–{{currentYear}} CYBERTEC PostgreSQL International GmbH",
    "about": "Über uns",
    "imprint": "Impressum"
  },
  "not_found": {
    "code_descriptions": {
      "404": "Seite nicht gefunden",
      "403": "Verboten"
    },
    "take_me_back": "Zurück"
  },
  "maintenance": {
    "title": "Wartung",
    "subtitle": "Hoppla!",
    "description": "Etwas ist schief gelaufen, die API ist nicht erreichbar.",
    "contact_line": "Bitte kontaktieren Sie den zuständigen Administrator, um dieses Problem zu beheben."
  },
  "page": {
    "home": "Start"
  },
  "notifications": {
    "no_notifications": "Sie haben keine Benachrichtigungen",
    "labels": {
      "status_dd": "Status:",
      "accept": "Annehmen",
      "decline": "Ablehnen",
      "mute": "Stumm",
      "mark_all_as_read": "Alle als gelesen markieren",
      "see_more": "Mehr...",
      "see_less": "Weniger..."
    },
    "templates": {
      "user_added_you_to_project": "{{user}} hat Sie zu einem Projekt hinzugefügt",
      "user_removed_you_from_project": "{{user}} hat Sie aus einem Projekt entfernt",
      "user_invited_you_to_join": "{{user}} hat Sie eingeladen",
      "user_removed_you_from_organization": "{{user}} hat Sie von einer Organisation entfernt",
      "you_have_pending_invitations": "Sie haben keine ausstehenden Einladungen",
      "count_invitations": "{{count}} Einladung",
      "count_invitations_plural": "{{count}} Einladungen",
      "you_invited_to_organization": "Sie wurden zu {{organizationName}} eingeladen"
    }
  }
}
